import { render, staticRenderFns } from "./FinalizacaoDetalhar.vue?vue&type=template&id=6cefef23"
import script from "./FinalizacaoDetalhar.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports